import React, { useState, useEffect } from "react";
import Sidebar from "../PPT/Sidebar";
import { MAX_TITLE_LENGTH } from "../../data/constant";
import {
  TbTextSize,
  TbPhotoVideo,
  TbChartBar,
  TbTable,
  TbPhoto,
  TbEdit,
} from "react-icons/tb";
import { MdOutlineSummarize } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import Button from "../ui/Button";
import { CiCircleInfo } from "react-icons/ci";
import { BlobServiceClient } from "@azure/storage-blob";
import { DEFAULT_TEXT_OBJECT, LAYOUT_OPTIONS } from "../../data";
import pptxgen from "pptxgenjs";
import {
  generateChartDataUsingLLM,
  generateTableDataUsingLLM,
  generateTextDataUsingLLM,
  generateTextDataUsingLLMFromSummary,
  getTextFromObjects,
  summarizeTextUsingLLM,
} from "../../utils/function";
import {
  containerName,
  PPT2IMG_BACKEND_URL,
  sasToken,
  storageAccountName,
} from "../../data/constant";

function EditGenericSlide({
  isOpen,
  setIsOpen,
  activeSlideConfig,
  onEditSlide,
  activeSlideNumber,
}) {
  const [activeTab, setActiveTab] = useState("content");
  const [titleText, setTitleText] = useState("");
  const [contentText, setContentText] = useState("");
  const [initialTitle, setInitialTitle] = useState("");
  const [initialContent, setInitialContent] = useState("");
  const [error, setError] = useState("");
  const [isSummarized, setIsSummarized] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasGeneratedContent, setHasGeneratedContent] = useState(false);
  const [generatedContentIndex, setGeneratedContentIndex] = useState(-1);
  const [generatedContentType, setGeneratedContentType] = useState(null);
  const [hasChartOrTable, setHasChartOrTable] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [mediaItems, setMediaItems] = useState({
    images: [],
    tables: [],
    charts: [],
  });
  const [currentSlideConfig, setCurrentSlideConfig] = useState(null);
  const [hasDeletedMedia, setHasDeletedMedia] = useState(false);
  const [editingChartIndex, setEditingChartIndex] = useState(null);
  const [editChartData, setEditChartData] = useState({
    chartType: "",
    chartTitle: "",
    xAxisLabel: "",
    yAxisLabel: "",
  });

  // ... rest of the existing state and functions ...

  const handleEditChart = (chart, index) => {
    setEditingChartIndex(index);
    setEditChartData({
      chartType: chart.chartType || "bar",
      chartTitle: chart.title || "",
      xAxisLabel: chart.xAxisLabel || "",
      yAxisLabel: chart.yAxisLabel || "", 
    });
  };

  const handleChartTypeChange = (type) => {
    setEditChartData({
      ...editChartData,
      chartType: type
    });
  };

  const handleSaveChartChanges = async (originalIndex) => {
    try {
      setIsUpdating(true);
      
      const updatedConfig = {
        ...currentSlideConfig,
        slideDataArray: currentSlideConfig.slideDataArray.map((item, index) => {
          if (index === originalIndex) {
            return {
              ...item,
              chartType: editChartData.chartType,
              title: editChartData.chartTitle,
              xAxisLabel: editChartData.xAxisLabel,
              yAxisLabel: editChartData.yAxisLabel
            };
          }
          return item;
        })
      };

      // Generate new chart image with updated settings
      const chartItem = updatedConfig.slideDataArray[originalIndex];
      const chartImageUrl = await generateChartImage({
        chartData: chartItem.data,
        chartType: editChartData.chartType,
        chartTitle: editChartData.chartTitle,
        xAxisLabel: editChartData.xAxisLabel,
        yAxisLabel: editChartData.yAxisLabel,
      });

      if (!chartImageUrl) {
        setError("Failed to generate updated chart image");
        return;
      }

      updatedConfig.slideDataArray[originalIndex].imageUrl = chartImageUrl;

      console.log("updatedConfig xxxxxxx", updatedConfig);

      // await onEditSlide(updatedConfig);
      setEditingChartIndex(null);
      setCurrentSlideConfig(updatedConfig);

    } catch (error) {
      console.error("Error updating chart:", error);
      setError("Failed to update chart");
    } finally {
      setIsUpdating(false);
    }
  };

  // ... rest of existing functions ...

  console.log("activeSlideConfig", activeSlideConfig);

  const MAX_CONTENT_LENGTH = 256;

  useEffect(() => {
    if (isOpen && activeSlideConfig) {
      setCurrentSlideConfig(JSON.parse(JSON.stringify(activeSlideConfig)));
    }
  }, [isOpen, activeSlideConfig]);

  useEffect(() => {
    if (isOpen && currentSlideConfig) {
      setTitleText(currentSlideConfig.title || "");
      setInitialTitle(currentSlideConfig.title || "");

      const generatedItem = currentSlideConfig?.slideDataArray?.find(
        (item) => item.isGeneratedByContent === true
      );

      const hasChartOrTableContent = currentSlideConfig?.slideDataArray?.some(
        (item) =>
          item.type === "chart" ||
          item.type === "table" ||
          item.type === "image"
      );
      setHasChartOrTable(hasChartOrTableContent);

      // Categorize media items by type
      const categorizedMedia = currentSlideConfig?.slideDataArray?.reduce(
        (acc, item, index) => {
          if (item.type === "image") {
            acc.images.push({ ...item, originalIndex: index });
          } else if (item.type === "table") {
            acc.tables.push({ ...item, originalIndex: index });
          } else if (item.type === "chart") {
            acc.charts.push({ ...item, originalIndex: index });
          }
          return acc;
        },
        { images: [], tables: [], charts: [] }
      ) || { images: [], tables: [], charts: [] };

      setMediaItems(categorizedMedia);

      if (generatedItem) {
        const index = currentSlideConfig.slideDataArray.indexOf(generatedItem);
        setGeneratedContentIndex(index);
        setHasGeneratedContent(true);
        setGeneratedContentType(generatedItem.type);
      } else {
        setGeneratedContentIndex(-1);
        setHasGeneratedContent(false);
        setGeneratedContentType(null);
      }

      const textContent = currentSlideConfig?.slideDataArray?.find(
        (item) => item.type === "text"
      );

      const text = textContent
        ? getTextFromObjects(currentSlideConfig?.slideDataArray)
        : "";

      setContentText(text);
      setInitialContent(text);
      setIsSummarized(false);
    }
  }, [isOpen, currentSlideConfig]);

  useEffect(() => {
    if (!isOpen) {
      setTitleText("");
      setContentText("");
      setInitialTitle("");
      setInitialContent("");
      setActiveTab("content");
      setError("");
      setIsSummarized(false);
      setIsLoading(false);
      setHasGeneratedContent(false);
      setGeneratedContentIndex(-1);
      setGeneratedContentType(null);
      setHasChartOrTable(false);
      setIsUpdating(false);
      setCurrentSlideConfig(null);
      setHasDeletedMedia(false);
      setMediaItems({ images: [], tables: [], charts: [] });
    }
  }, [isOpen]);

  // ... rest of the functions remain same until handleMediaDelete ...
  const handleTextChange = (e) => {
    setTitleText(e.target.value);
    setIsSummarized(false);
  };

  const handleContentChange = (e) => {
    if (e.target.value.length > MAX_CONTENT_LENGTH) {
      setError(`Content cannot exceed ${MAX_CONTENT_LENGTH} characters`);
    } else {
      setError("");
    }
    setContentText(e.target.value);
    setIsSummarized(false);
  };

  const handleSummarize = async () => {
    setIsLoading(true);
    setError("");
    try {
      const summarizedText = await summarizeTextUsingLLM(contentText, 100);
      console.log("Summarized text:", summarizedText);
      setContentText(summarizedText);
      setIsSummarized(true);
    } catch (error) {
      console.error("Error summarizing:", error);
      setError("Failed to summarize content");
      setIsSummarized(false);
    } finally {
      setIsLoading(false);
    }
  };

  async function uploadFileToBlob2(fileBlob, fileName) {
    try {
      console.info("Uploading file to blob storage");
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
      );
      const containerClient =
        blobServiceClient.getContainerClient(containerName);
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);

      await blockBlobClient.uploadBrowserData(fileBlob, {
        blobHTTPHeaders: { blobContentType: fileBlob.type },
      });

      const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;

      try {
        const response = await fetch(PPT2IMG_BACKEND_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ pptxUrl: fileUrl }),
        });

        if (!response.ok) {
          throw new Error("Failed to convert PPTX to PDF");
        }

        const data = await response.json();
        return data.uploadedUrls[0];
      } catch (error) {
        throw error;
      }
    } catch (error) {
      throw error;
    }
  }

  async function generateChartImage({
    chartData,
    chartType,
    chartTitle,
    xAxisLabel,
    yAxisLabel,
  }) {
    return new Promise(async (resolve, reject) => {
      console.log("Going to generate chart image");
      console.log("chartData is ", chartData);
      console.log("chartType", chartType);
      console.log("chartTitle", chartTitle);
      console.log("xAxisLabel", xAxisLabel);
      console.log("yAxisLabel", yAxisLabel);
      try {
        console.info("Generating chart image");
        let pptxV2 = new pptxgen();
        let newSlide = pptxV2.addSlide();

        const newChartData = [...chartData];
        console.log("newChartData is ", newChartData);

        newSlide.addChart(pptxV2.ChartType[chartType], newChartData, {
          ...LAYOUT_OPTIONS.LAYOUT_1_MEDIA_FULL_OPTIONS_CHART,
          title: "chartTitle",
          showTitle: true,
          catAxisTitle: xAxisLabel,
          valAxisTitle: yAxisLabel,
        });

        const base64String = await pptxV2.write("base64");
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const pptBlob = new Blob([byteArray], {
          type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        });

        const imageUrl = await uploadFileToBlob2(pptBlob, `codemonk.pptx`);
        resolve(imageUrl);
      } catch (error) {
        reject(error);
      }
    });
  }

  async function generateTableImage(extractedData) {
    console.info("Generating PPT slide with table");
    return new Promise(async (resolve) => {
      let pptx = new pptxgen();
      let slide = pptx.addSlide();

      slide.addTable(extractedData, {
        ...LAYOUT_OPTIONS.LAYOUT_1_MEDIA_FULL_OPTIONS_TABLE,
      });

      pptx.write("base64").then(async (base64String) => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const pptBlob = new Blob([byteArray], {
          type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        });

        const res = await uploadFileToBlob2(pptBlob, `codemonk.pptx`);
        resolve(res);
      });
    });
  }

  const isChanged =
    titleText !== initialTitle ||
    contentText !== initialContent ||
    hasDeletedMedia;

  const isUpdateDisabled = () => {
    // Disable if loading or updating
    console.log("isUpdateDisabled 1", isLoading, isUpdating);
    if (isLoading || isUpdating) return true;

    // Enable if title changed
    console.log("isUp", titleText !== initialTitle);
    if (titleText !== initialTitle) return false;

    // Enable if content changed and summarized
    console.log("isUp 2", contentText !== initialContent && isSummarized);
    if (contentText !== initialContent && isSummarized) return false;

    console.log("isUp 3", hasDeletedMedia);
    // Enable if media was deleted
    if (hasDeletedMedia) return false;

    // console.log("isUp 4 hasChanges",hasChanges)
    // Check if any changes were made
    const hasChanges =
      titleText !== initialTitle ||
      (contentText !== initialContent && isSummarized) ||
      hasDeletedMedia;
    console.log("isUp 5 hasChanges", hasChanges);
    // Disable if no changes
    if (!hasChanges) return true;
    console.log("isUp 6 error", error);
    // Disable if there's an error
    if (error) return true;

    return false;
  };
  const handleMediaDelete = (originalIndex) => {
    const updatedConfig = {
      ...currentSlideConfig,
      slideDataArray: currentSlideConfig.slideDataArray.filter(
        (_, index) => index !== originalIndex
      ),
    };

    // Update categorized media items
    const updatedMediaItems = {
      images: mediaItems.images.filter(
        (item) => item.originalIndex !== originalIndex
      ),
      tables: mediaItems.tables.filter(
        (item) => item.originalIndex !== originalIndex
      ),
      charts: mediaItems.charts.filter(
        (item) => item.originalIndex !== originalIndex
      ),
    };
    console.log("updatedMediaItems",updatedMediaItems)

    setMediaItems(updatedMediaItems);
    setHasChartOrTable(
      updatedMediaItems.images.length > 0 ||
        updatedMediaItems.tables.length > 0 ||
        updatedMediaItems.charts.length > 0
    );
    setCurrentSlideConfig(updatedConfig);
    setHasDeletedMedia(true);
  };

  return (
    <Sidebar
      open={isOpen}
      setOpen={setIsOpen}
      isLoading={isLoading || isUpdating}
      title={`Edit Slide ${activeSlideNumber}  `}
      onConfirm={async () => {
        // ... existing onConfirm logic ...
        setIsUpdating(true);
        setError("");
        try {
          console.info("Updating slide content", {
            title: titleText,
            content: contentText,
            hasGeneratedContent,
            generatedContentIndex,
            generatedContentType,
          });

          let updatedConfig = null;

          // If has generated content, generate and validate all new data first
          if (
            hasGeneratedContent &&
            generatedContentIndex >= 0 &&
            isSummarized
          ) {
            console.log("generatedContentType", generatedContentType);
            console.log("isSummarized", isSummarized);

            if (generatedContentType === "chart") {
              console.log("Inside chart generation branch");
              // Generate chart data first
              const newChartData = await generateChartDataUsingLLM(contentText);
              if (!newChartData) {
                setError("Failed to generate chart data");
                return;
              }

              // Generate text data
              const newTextData = await generateTextDataUsingLLMFromSummary(
                contentText
              );
              console.log("newTextData is ", newTextData);
              if (!newTextData) {
                setError(
                  "Failed to generate text data. Please try summarizing again."
                );
                setIsSummarized(false);
                return;
              }

              // Generate chart image
              const chartImageUrl = await generateChartImage({
                chartData: newChartData,
                chartType:
                  currentSlideConfig.slideDataArray[generatedContentIndex]
                    .chartType,
                chartTitle: titleText,
                xAxisLabel:
                  currentSlideConfig.slideDataArray[generatedContentIndex]
                    .xAxisLabel,
                yAxisLabel:
                  currentSlideConfig.slideDataArray[generatedContentIndex]
                    .yAxisLabel,
              });
              if (!chartImageUrl) {
                setError("Failed to generate chart image");
                return;
              }

              // Only create updated config once all data is generated successfully
              updatedConfig = {
                ...currentSlideConfig,
                title: titleText,
                slideDataArray: [...currentSlideConfig.slideDataArray],
              };
              // Update chart data at generatedContentIndex
              updatedConfig.slideDataArray[generatedContentIndex] = {
                ...updatedConfig.slideDataArray[generatedContentIndex],
                data: newChartData,
                imageUrl: chartImageUrl,
              };
              // Update text data for any text type elements
              updatedConfig.slideDataArray = updatedConfig.slideDataArray.map(
                (item) => {
                  if (item.type === "text") {
                    return {
                      ...item,
                      data: newTextData,
                    };
                  }
                  return item;
                }
              );

              console.log("updatedConfig is ", updatedConfig);
            } else if (generatedContentType === "table") {
              console.log("Inside table generation branch");
              // Generate table data first
              const newTableData = await generateTableDataUsingLLM(contentText);
              if (!newTableData) {
                setError("Failed to generate table data");
                return;
              }

              // Generate text data
              const newTextData = await generateTextDataUsingLLMFromSummary(
                contentText
              );
              console.log("newTextData is ", newTextData);
              if (!newTextData) {
                setError(
                  "Failed to generate text data. Please try summarizing again."
                );
                setIsSummarized(false);
                return;
              }

              // Generate table image
              const tableImageUrl = await generateTableImage(newTableData);
              if (!tableImageUrl) {
                setError("Failed to generate table image");
                return;
              }

              updatedConfig = {
                ...currentSlideConfig,
                title: titleText,
                slideDataArray: [...currentSlideConfig.slideDataArray],
              };
              // Update table data at generatedContentIndex
              updatedConfig.slideDataArray[generatedContentIndex] = {
                ...updatedConfig.slideDataArray[generatedContentIndex],
                data: newTableData,
                imageUrl: tableImageUrl,
              };
              // Update text data for any text type elements
              updatedConfig.slideDataArray = updatedConfig.slideDataArray.map(
                (item) => {
                  if (item.type === "text") {
                    return {
                      ...item,
                      data: newTextData,
                    };
                  }
                  return item;
                }
              );

              console.log("updatedConfig is ", updatedConfig);
            }
          } else if (contentText !== initialContent) {
            console.log("Inside content update branch");
            // Handle cases based on slideDataArray content
            const slideDataArray = currentSlideConfig?.slideDataArray || [];

            // Case 1: Empty slideDataArray
            if (slideDataArray.length === 0) {
              console.log("Inside empty slideDataArray case");
              const newTextData = await generateTextDataUsingLLMFromSummary(
                contentText
              );
              updatedConfig = {
                ...currentSlideConfig,
                title: titleText,
                layout: "v1",
                slideDataArray: [
                  {
                    type: "text",
                    ...DEFAULT_TEXT_OBJECT,
                    data: newTextData,
                  },
                ],
              };
            }

            // Case 2: Single text object
            else if (
              slideDataArray.length === 1 &&
              slideDataArray[0].type === "text"
            ) {
              console.log("Inside single text object case");
              const newTextData = await generateTextDataUsingLLMFromSummary(
                contentText
              );
              updatedConfig = {
                ...currentSlideConfig,
                title: titleText,
                slideDataArray: [
                  {
                    ...slideDataArray[0],
                    data: newTextData,
                  },
                ],
              };
            }

            // Case 3: Media objects present
            else if (
              slideDataArray.some((item) =>
                ["chart", "image", "table"].includes(item.type)
              )
            ) {
              console.log("Inside media objects case - main branch");
              const newTextData = await generateTextDataUsingLLMFromSummary(
                contentText
              );
              const mediaObjects = slideDataArray.filter((item) =>
                ["chart", "image", "table"].includes(item.type)
              );

              // Check if text object already exists
              const textObjectIndex = slideDataArray.findIndex(
                (item) => item.type === "text"
              );

              if (mediaObjects.length === 1) {
                console.log("Inside single media object case - main branch");
                // One media object - add/update text and set layout to v2
                let newSlideDataArray;
                if (textObjectIndex >= 0) {
                  // Update existing text object
                  newSlideDataArray = slideDataArray.map((item, index) => {
                    if (index === textObjectIndex) {
                      return {
                        ...item,
                        data: newTextData,
                      };
                    }
                    return item;
                  });
                } else {
                  // Add new text object at start
                  newSlideDataArray = [
                    {
                      type: "text",
                      ...DEFAULT_TEXT_OBJECT,
                      data: newTextData,
                    },
                    ...slideDataArray,
                  ];
                }

                updatedConfig = {
                  ...currentSlideConfig,
                  title: titleText,
                  layout: "v2",
                  slideDataArray: newSlideDataArray,
                };
              } else if (mediaObjects.length === 2) {
                console.log("Inside two media objects case - main branch");
                // Two media objects - add/update text and update layout
                const newLayout =
                  currentSlideConfig.layout === "v4"
                    ? "v4"
                    : currentSlideConfig.layout === "v9"
                    ? "v4"
                    : currentSlideConfig.layout === "v19"
                    ? "v14"
                    : currentSlideConfig.layout;

                let newSlideDataArray;
                if (textObjectIndex >= 0) {
                  // Update existing text object
                  newSlideDataArray = slideDataArray.map((item, index) => {
                    if (index === textObjectIndex) {
                      return {
                        ...item,
                        data: newTextData,
                      };
                    }
                    return item;
                  });
                } else {
                  // Add new text object at start
                  newSlideDataArray = [
                    {
                      type: "text",
                      ...DEFAULT_TEXT_OBJECT,
                      data: newTextData,
                    },
                    ...slideDataArray,
                  ];
                }

                updatedConfig = {
                  ...currentSlideConfig,
                  title: titleText,
                  layout: newLayout,
                  slideDataArray: newSlideDataArray,
                };
              }
            }
          } else {
            console.log("Inside title-only update branch");
            // If no generated content, just update title and/or apply media deletions
            updatedConfig = currentSlideConfig;
          }

          // Only update if we have valid config
          if (updatedConfig) {
            updatedConfig.title = titleText;
            console.log("Applying updated config: >>", updatedConfig);
            await onEditSlide(updatedConfig);
            setIsOpen(false);
          }
        } catch (error) {
          console.error("Error updating slide:", error);
          setError("Failed to update slide");
        } finally {
          setIsUpdating(false);
        }
      }}
      isDisabled={isUpdateDisabled()}
      rightCTA={isLoading || isUpdating ? "Please wait..." : "Update Slide"}
    >
      {/* ... existing tab buttons ... */}
      {hasChartOrTable && (
        <div className="flex w-full border-b mb-4">
          <button
            disabled={isLoading || isUpdating}
            className={`flex-1 flex items-center justify-center gap-2 px-4 py-2 ${
              activeTab === "content"
                ? "border-b-2 border-blue-500 text-blue-500"
                : "text-gray-500"
            } ${
              isLoading || isUpdating ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={() => setActiveTab("content")}
          >
            <TbTextSize className="text-xl" />
            Content
          </button>
          <button
            disabled={isLoading || isUpdating}
            className={`flex-1 flex items-center justify-center gap-2 px-4 py-2 ${
              activeTab === "media"
                ? "border-b-2 border-blue-500 text-blue-500"
                : "text-gray-500"
            } ${
              isLoading || isUpdating ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={() => setActiveTab("media")}
          >
            <TbPhotoVideo className="text-xl" />
            Media
          </button>
        </div>
      )}

      {(!hasChartOrTable || activeTab === "content") && (
        <div className="space-y-4">
          <div>
            <h2 className="text-base font-bold mb-2">Title</h2>
            <input
              type="text"
              maxLength={MAX_TITLE_LENGTH}
              value={titleText}
              onChange={handleTextChange}
              className={`w-full p-2 border rounded-md ${
                isLoading || isUpdating ? "bg-gray-100" : ""
              }`}
              placeholder="Enter slide title"
              disabled={isLoading || isUpdating}
            />
          </div>

          <div>
            <h2 className="text-base font-bold mb-2">Content</h2>
            <textarea
              value={contentText}
              onChange={handleContentChange}
              className={`w-full h-[200px] p-2 border rounded-md ${
                error ? "border-red-500" : ""
              } ${isLoading || isUpdating ? "bg-gray-100" : ""}`}
              placeholder="Enter slide content"
              disabled={isLoading || isUpdating}
            />
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
            <p className="text-sm text-gray-500 mt-1">
              {contentText.length}/{MAX_CONTENT_LENGTH} characters
            </p>
            <Button
              onClick={handleSummarize}
              className={`flex items-center justify-center gap-2 mt-2 w-full ${
                isLoading || isUpdating || !contentText.trim()
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
              type="outline"
              disabled={isLoading || isUpdating || !contentText.trim()}
            >
              <MdOutlineSummarize className="text-xl" />
              {isLoading ? "Summarizing..." : "Summarize Content"}
            </Button>
            <div className="p-2 mt-4 bg-gray-100 flex gap-3 items-center rounded-md text-sm">
              <CiCircleInfo className="text-3xl mt-1 text-blue-500" />
              {hasGeneratedContent
                ? `This slide contains a generated ${generatedContentType} that will update automatically`
                : "If the chart/table is slide-generated, updating the content will update the table automatically"}
            </div>
          </div>
        </div>
      )}
      {hasChartOrTable && activeTab === "media" && (
        <div className="space-y-6">
          {mediaItems.images.length > 0 && (
            <div className="space-y-2">
              <h3 className="font-medium text-gray-700">Images</h3>
              {mediaItems.images.map((item) => (
                <div
                  key={item.originalIndex}
                  className="flex items-center justify-between p-4 border rounded-md"
                >
                  <div className="flex items-center gap-2">
                    <TbPhoto className="text-xl" />
                    <span className="truncate max-w-[200px] inline-block">
                      {item?.path?.split("/").pop()}
                    </span>
                  </div>
                  <button
                    className="text-red-500 hover:text-red-700"
                    onClick={() => handleMediaDelete(item.originalIndex)}
                    disabled={isLoading || isUpdating}
                  >
                    <RiDeleteBin6Line className="text-xl" />
                  </button>
                </div>
              ))}
            </div>
          )}

          {mediaItems.tables.length > 0 && (
            <div className="space-y-2">
              <h3 className="font-medium text-gray-700">Tables</h3>
              {mediaItems.tables.map((item) => (
                <div
                  key={item.originalIndex}
                  className="flex items-center justify-between p-4 border rounded-md"
                >
                  <div className="flex items-center gap-2">
                    <TbTable className="text-xl" />
                    <span className="truncate max-w-[200px] inline-block">
                      {item?.imageUrl?.split("/").pop()}
                    </span>
                  </div>
                  <button
                    className="text-red-500 hover:text-red-700"
                    onClick={() => handleMediaDelete(item.originalIndex)}
                    disabled={isLoading || isUpdating}
                  >
                    <RiDeleteBin6Line className="text-xl" />
                  </button>
                </div>
              ))}
            </div>
          )}

          {mediaItems.charts.length > 0 && (
            <div className="space-y-2">
              <h3 className="font-medium text-gray-700">Charts</h3>
              {mediaItems.charts.map((item) => (
                <div key={item.originalIndex} className="space-y-4">
                  <div className="flex items-center justify-between p-4 border rounded-md">
                    <div className="flex items-center gap-2">
                      <TbChartBar className="text-xl" />
                      <span className="truncate max-w-[200px] inline-block">
                        {item?.imageUrl?.split("/").pop()}
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      {/* <button
                        className="text-blue-500 hover:text-blue-700"
                        onClick={() => handleEditChart(item, item.originalIndex)}
                        disabled={isLoading || isUpdating}
                      >
                        <TbEdit className="text-xl" />
                      </button> */}
                      <button
                        className="text-red-500 hover:text-red-700"
                        onClick={() => handleMediaDelete(item.originalIndex)}
                        disabled={isLoading || isUpdating}
                      >
                        <RiDeleteBin6Line className="text-xl" />
                      </button>
                    </div>
                  </div>

                  {editingChartIndex === item.originalIndex && (
                    <div className="p-4 border rounded-md bg-gray-50">
                      <div className="space-y-4">
                        <div>
                          <h4 className="font-medium text-gray-700 mb-2">Chart Type</h4>
                          <div className="flex gap-2">
                            <button
                              onClick={() => handleChartTypeChange("bar")}
                              className={`flex-1 h-16 border flex flex-col gap-1 items-center justify-center rounded-md ${
                                editChartData.chartType === "bar" ? "bg-blue-50 border-blue-500" : ""
                              }`}
                            >
                              <TbChartBar className="text-xl" />
                              <span>Bar Chart</span>
                            </button>
                            <button
                              onClick={() => handleChartTypeChange("line")}
                              className={`flex-1 h-16 border flex flex-col gap-1 items-center justify-center rounded-md ${
                                editChartData.chartType === "line" ? "bg-blue-50 border-blue-500" : ""
                              }`}
                            >
                              <TbChartBar className="text-xl" />
                              <span>Line Chart</span>
                            </button>
                          </div>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Chart Title
                          </label>
                          <input
                            type="text"
                            value={editChartData.chartTitle}
                            onChange={(e) =>
                              setEditChartData({
                                ...editChartData,
                                chartTitle: e.target.value,
                              })
                            }
                            className="w-full p-2 border rounded-md"
                            placeholder="Enter chart title"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            X-Axis Label
                          </label>
                          <input
                            type="text"
                            value={editChartData.xAxisLabel}
                            onChange={(e) =>
                              setEditChartData({
                                ...editChartData,
                                xAxisLabel: e.target.value,
                              })
                            }
                            className="w-full p-2 border rounded-md"
                            placeholder="Enter X-axis label"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Y-Axis Label
                          </label>
                          <input
                            type="text"
                            value={editChartData.yAxisLabel}
                            onChange={(e) =>
                              setEditChartData({
                                ...editChartData,
                                yAxisLabel: e.target.value,
                              })
                            }
                            className="w-full p-2 border rounded-md"
                            placeholder="Enter Y-axis label"
                          />
                        </div>

                        <div className="flex gap-2 pt-2">
                          <button
                            onClick={() => setEditingChartIndex(null)}
                            className="flex-1 py-2 px-4 border border-gray-300 rounded-md hover:bg-gray-50"
                          >
                            Close
                          </button>
                          <button
                            onClick={() => handleSaveChartChanges(item.originalIndex)}
                            className="flex-1 py-2 px-4 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                            disabled={isUpdating}
                          >
                            {isUpdating ? "Saving..." : "Save Changes"}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

 
    </Sidebar>
  );
}

export default EditGenericSlide;
